import type { MarketDataDto } from "../../types/MarketDataDto";
import { createAuthenticatedApiClient } from "./AuthenticatedApiClient";

type ApiClient = ReturnType<typeof createAuthenticatedApiClient>;

export function createMarketDataApi(apiClient: ApiClient) {
    const getMarketData = async (query: URLSearchParams): Promise<MarketDataDto | null> => {
        try {
            const response = await apiClient.get<MarketDataDto>("api/market-data", {
                params: query,
            });

            return response?.data ?? null;
        } catch (error: any) {
            console.log(error);
            return null;
        }
    };

    return {
        getMarketData,
    };
}
